import Accordion from "react-bootstrap/Accordion";
type accordionItem = {
  accordionHeader: React.ReactElement;
  accordionBody: React.ReactElement;
  disabled: boolean;
  others?: React.ReactNode;
};
interface props {
  accordionItems: accordionItem[];
}
const ReceivingAccordion: React.FC<props> = ({ accordionItems }) => {
  return (
    <Accordion className="receiving-accordion" defaultActiveKey="0">
      {accordionItems?.map((item, idx) => (
        <div key={idx}>
          <Accordion.Item
            eventKey={idx.toString()}
            className="receiving-accordion-item"
          >
            <Accordion.Button disabled={item.disabled} className="p-3">
              {item.accordionHeader}
            </Accordion.Button>

            <Accordion.Body>{item.accordionBody}</Accordion.Body>
          </Accordion.Item>
          {item.others}
        </div>
      ))}
    </Accordion>
  );
};

export default ReceivingAccordion;
